export const firebaseConfig = {
  apiKey: "AIzaSyCIIKGekohgs2HP9qeXKKzjgMk_WlmiCIM",
  authDomain: "unops-infraigss-prod.firebaseapp.com",
  projectId: "unops-infraigss-prod",
  storageBucket: "unops-infraigss-prod.firebasestorage.app",
  messagingSenderId: "1003974699275",
  appId: "1:1003974699275:web:6add1ad49e31eb5fdbda0e"
};  